<script>
export default {
  name: "privacyPage",
  data(){
    return {
    }
  },
  created() {

  },
  methods:{

  }
}
</script>

<template>
<div class="privacy-container">
  <div class="container" v-if="$i18n.locale === 'en'">
    <h4 class="title">Privacy Statement</h4>
    <p>Effective Date: from 23<sup>rd</sup> October, 2014</p>
    <p>This Privacy Statement has been translated into Chinese. In case of inconsistency or ambiguity between the English and Chinese versions, the English version shall prevail.</p>
    <h5 class="mt-4">Collection of Personal Data</h5>
    <p class="mt-3">Monkey Tree English Learning Center Limited (“Monkey Tree English Learning Center”, “Monkey Tree”, “MTELC”, “we”, “us”, or “our”) collects personal data that we believe to be relevant and required to provide the best service to you.</p>
    <p class="mt-3">Our services include, but are not limited to, the following:</p>
    <ul class="mt-3" >
      <li><p>Processing your application and registration</p></li>
      <li><p>Replying to your or your child’s inquiries, concerns or complaints</p></li>
      <li><p>Direct marketing, such as delivering news, offers and promotions relevant for you or your child</p></li>
      <li><p>Providing up-to-date information regarding your or your child’s attendance, progress and upcoming classes</p></li>
      <li><p>Assigning available and best suited classes to you or your child</p></li>
      <li><p>Providing relevant class materials for you or your child during class</p></li>
      <li><p>Issuing invoices, collecting course fees, issuing receipts, and maintaining your payment history</p></li>
    </ul>
    <p class="mt-3">All direct marketing activities will be relevant to current Monkey Tree events, promotions and updates. Monkey Tree will endeavor to limit all direct marketing activities to contain material strictly relevant to you personally.</p>
    <p class="mt-3">If you prefer your personal data not to be used for the purposes of direct marketing activities, please send an email to
      <a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com</a> containing the following information:</p>
    <ul class="mt-3">
      <li>a.Your name</li>
      <li>b.Your related information</li>
      <li>c.Your intention to opt-out of Monkey Tree’s direct marketing activities</li>
    </ul>
    <h5 class="mt-4">Accuracy of your Personal Information</h5>
    <p class="mt-3">We will, as manageable by our best effort, keep your personal data accurate and up-to date.</p>
    <p class="mt-3">We rely on you to disclose all material information to us and to inform us of any errors or changes in such information.</p>
    <p class="mt-3">If you would like to notify us of any changes, such as a change of your contact number, please e-mail us at
      <a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com</a>.</p>
    <h5 class="mt-4">Disclosing Your Personal Information</h5>
    <p class="mt-3">We keep all personal data strictly confidential, and we will not disclose personal data outside of Monkey Tree unless we have your consent or are required to by law.</p>
    <p class="mt-3">We may transfer your personal data to third parties such as employees, related companies, including subsidiaries and associated companies, as necessary to provide the best service to you.</p>
    <h5 class="mt-4">Protecting and Retaining Your Personal Information</h5>
    <p class="mt-3">We maintain appropriate security systems to prevent unauthorized access to all personal data.</p>
    <p class="mt-3">We retain personal data for no longer than is required to fulfill the purpose or any directly related purposes for which the data is to be used, subject to legal, statutory and regulatory requirements for the retention of data.</p>
    <p class="mt-3">If you have any questions or concerns regarding Monkey Tree’s Privacy Statement or want to delete the personal information submitted, please feel free to contact us at <span><a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com</a></span> or write to the following address:</p>
    <p class="mt-3">Suite 2514, 25/F, 1111 King’s Road,</p>
    <p class="mt-3">Taikoo Shing, Hong Kong</p>
    <h5 class="mt-4">Statement on Photography and Videography</h5>
    <p class="mt-3">Monkey Tree will occasionally take photographs and videos of students and employees with as little disturbance to the class or center environment as possible. Such photographs and videos may be published, and viewed by the general public, in hard copy, via electronic media or on the website. If you object to your or your child’s photograph being published or wish to restrict its use, 
      please notify us at <a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com</a> containing the following information:</p>
    <ul class="mt-3">
      <li>1.Your or your child’s name</li>
      <li>2.Your contact number (as registered at Monkey Tree)</li>
      <li>3.The Monkey Tree Center which you or your child attends</li>
    </ul>
    <p class="mt-3">Changes to this Privacy Statement</p>
    <p class="mt-3">We update our Privacy Statement from time to time without prior notice. We encourage you to check this Website occasionally to ensure that you are aware of the most recent terms.</p>
  </div>
  <div class="container" v-else-if="$i18n.locale === 'zh-CN'">
    <h4 class="title">私隐声明</h4>
    <p>本条例自2014年10月23日起生效</p>
    <p>此隐私保护条例的中文版本是基于英文条例之翻译版本，如条例中出现解释模糊或定义不清情况最终以英文条例为参考。</p>
    <h5 class="mt-4">个人资料收集</h5>
    <p class="mt-3">我们对您个人资料的收集目的是为了提供更优质的服务。</p>
    <p class="mt-3">我们的服务包括但不局限于：</p>
    <ul class="mt-3" >
      <li><p>处理您的申请与登记</p></li>
      <li><p>回复您的各项问题及投诉建议</p></li>
      <li><p>为您及时提供中心的最新消息</p></li>
      <li><p>为您及时提供孩子的学习状况</p></li>
      <li><p>为您及时提供最合适孩子的课程以及上课时段</p></li>
      <li><p>为学生提供上课所需教材</p></li>
      <li><p>处理您的各项消费记录及单据</p></li>
    </ul>
    <p class="mt-3">我们会尽力确保您可以及时收到最新的资讯。</p>
    <p class="mt-3">如果您不愿接收到我们的新资讯，请将以下信息发送至 <a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com。</a></p>
    <ul class="mt-3">
      <li>a.您的姓名</li>
      <li>b.您的相关资料</li>
      <li>c.您不愿收到新资讯的原因</li>
    </ul>
    <h5 class="mt-4">保证您个人资料准确无误</h5>
    <p class="mt-3">我们会尽力保证您的个人资料即时更新及准确无误。</p>
    <p class="mt-3">我们将会以您留给我们的资料来与您联系。</p>
    <p class="mt-3">如果您需要更新您的资料请发邮件到 <a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com。</a></p>
    <h5 class="mt-4">个人信息保障</h5>
    <p class="mt-3">我们将会对您的个人资料严格保密。未经您的同意我们不会将您的任何资料用于或公开给非Monkey Tree之用途。</p>
    <p class="mt-3">我们会将您的部分个人资料转给第三方，如：公司雇员、或关联公司其中包括子公司、合作伙伴等，目的是为您提供更好地服务。</p>
    <h5 class="mt-4">个人资料的保存</h5>
    <p class="mt-3">我们会以适合的安保系统来管理您的资料以防止未经授权的浏览。</p>
    <p class="mt-3">我们对您个人资料的保留时间不会长于达致资料用途（或任何直接相关的目的）所需的时间，且须受与保留资料有关的法律、法定及监管规定的规限。</p>
    <p class="mt-3">I如果您对我们的相关政策有任何疑问请与我们联系。 <span><a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com</a></span> 或将信件寄往以下地址:</p>
    <p class="mt-3">香港太古城英皇道1111号</p>
    <p class="mt-3">25樓2514室</p>
    <h5 class="mt-4">影像声明</h5>
    <p class="mt-3">Monkey Tree 会在不影响课堂的情况下拍摄一些学生或老师的照片或录像。这些照片或影像会出现在公共场所及网络。如果您拒绝这些照片或影像出现在公共场所及网络，请以邮
      件的方式告知我们 <a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com </a> 邮件内容包括：</p>
    <ul class="mt-3">
      <li>1.您和您孩子的姓名</li>
      <li>2.您的联系电话</li>
      <li>3.您所在的分校名称</li>
    </ul>
    <p class="mt-3">隐私声明变更</p>
    <p class="mt-3">我们会不定时对隐私声明进行更新，更新前亦不会做出通知。您可以经常登录本网站已查询最新条款。</p>
  </div>
  <div class="container" v-else>
    <h4 class="title">私隱聲明</h4>
    <p>本條例自2014年10月23日起生效</p>
    <p>此隱私保護條例的中文版本是基於英文條例之翻譯版本，如條例中出現解釋模糊或定義不清情況最終以英文條例為參考。</p>
    <h5 class="mt-4">個人資料收集</h5>
    <p class="mt-3">我們對您個人資料的收集目的是為了提供更優質的服務。</p>
    <p class="mt-3">我們的服務包括但不局限於：</p>
    <ul class="mt-3" >
      <li><p>處理您的申請與登記</p></li>
      <li><p>回復您的各項問題及投訴建議</p></li>
      <li><p>為您及時提供中心的最新消息</p></li>
      <li><p>為您及時提供孩子的學習狀況</p></li>
      <li><p>為您及時提供最合適孩子的課程以及上課時段</p></li>
      <li><p>為學生提供上課所需教材</p></li>
      <li><p>處理您的各項消費記錄及單據</p></li>
    </ul>
    <p class="mt-3">我們會盡力確保您可以及時收到最新的資訊。</p>
    <p class="mt-3">如果您不願接收到我們的新資訊，請將以下信息發送至 <a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com。</a> </p>
    <ul class="mt-3">
      <li>a.您的姓名</li>
      <li>b.您的相關資料</li>
      <li>c.您不願收到新資訊的原因</li>
    </ul>
    <h5 class="mt-4">保證您個人資料準確無誤</h5>
    <p class="mt-3">我們會盡力保證您的個人資料即時更新及準確無誤。</p>
    <p class="mt-3">我們將會以您留給我們的資料來與您聯繫。</p>
    <p class="mt-3">如果您需要更新您的資料請發郵件到 <a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com。</a></p>
    <h5 class="mt-4">個人信息保障</h5>
    <p class="mt-3">我們將會對您的個人資料嚴格保密。未經您的同意我們不會將您的任何資料用於或公開給非Monkey Tree之用途。</p>
    <p class="mt-3">我們會將您的部分個人資料轉給第三方，如：公司僱員、或關聯公司其中包括子公司、合作夥伴等，目的是為您提供更好地服務。</p>
    <h5 class="mt-4">個人資料的保存</h5>
    <p class="mt-3">我們會以適合的安保系統來管理您的資料以防止未經授權的瀏覽。</p>
    <p class="mt-3">我們對您個人資料的保留時間不會長於達致資料用途（或任何直接相關的目的）所需的時間，且須受與保留資料有關的法律、法定及監管規定的規限。</p>
    <p class="mt-3">如果您對我們的相關政策有任何疑問或需刪除已提交的個人資料請與我們聯繫。<span><a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com</a></span> 將信件寄往以下地址:</p>
    <p class="mt-3">香港太古城英皇道1111號</p>
    <p class="mt-3">25樓2514室</p>
    <h5 class="mt-4">影像聲明</h5>
    <p class="mt-3">Monkey Tree 會在不影響課堂的情況下拍攝一些學生或老師的照片或錄像。這些照片或影像會出現在公共場所及網絡。如果您拒絕這些照片或影像出現在公共場所及網絡，請以郵
      件的方式告知我們 <a href="mailto:enquiry@ppmember.com">enquiry@ppmember.com</a> 郵件內容包括：</p>
    <ul class="mt-3">
      <li>1.您和您孩子的姓名</li>
      <li>2.您的聯繫電話</li>
      <li>3.您所在的分校名稱</li>
    </ul>
    <p class="mt-3">隱私聲明變更</p>
    <p class="mt-3">我們會不定時對隱私聲明進行更新，更新前亦不會做出通知。您可以經常登錄本網站已查詢最新條款。</p>
  </div>
</div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.privacy-container{
  padding-top: 8%;
  padding-bottom: 5%;
  @include media-max(xxl){
    padding: 10% 55px 20%;
  }
  h4{
    margin: 70px 0 50px 0;
    font-size: 1.5rem;
    font-weight: 500;
    &:before{
      content: "";
      display: inline-block;
      width: 3px;
      height: 16px;
      background: #009539;
      margin-right: 12px;
    }
  }
  h5{
    font-size: 1.25rem;
    font-weight: 500;
  }
  a{
    color: #485154;
  }
  ul{
    padding-left: 2%;
  }
}
</style>